module.exports = __webpack_public_path__ + "img/About.9c088b4c.png";